import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  BankDetailsForm,
  Breadcrumbs,
  Button,
  ProjectAmenitiesForm,
  ProjectForm,
  ProjectNearbyForm,
  ProjectPhasesForm,
} from "../../components";
import { useProject } from "../../hooks";

const NewProjectFormPage = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const formStages = [
    "project_details_form",
    "project_amenities_form",
    "project_stores_form",
    "project_phases_form",
    "project_bank_details_form",
  ];
  const { createNewProject } = useProject();

  useEffect(() => {
    const currentFormStage = localStorage.getItem("currentFormStage");
    if (currentFormStage) setCurrentStep(formStages.indexOf(currentFormStage));
    else {
      localStorage.setItem("currentFormStage", formStages[0]);
      setCurrentStep(0);
    }
  }, []);

  // Move to the next step for the form
  const handleSetNextStep = (data) => {
    const savedData = JSON.parse(localStorage.getItem("new_project_data"));
    if (currentStep < formStages.length - 1) {
      localStorage.setItem("new_project_data", JSON.stringify({ ...savedData, ...data }));
      setCurrentStep((prev) => prev + 1);
      localStorage.setItem("currentFormStage", formStages[currentStep + 1]);
    }
  };

  const navigate = useNavigate();
  const handleSubmit = async () => {
    const savedData = JSON.parse(localStorage.getItem("new_project_data"));
    const savedBankData = JSON.parse(localStorage.getItem(formStages[4]));
    if (!savedData) {
      handleClearForm();
      toast.error("An error occurred, please try again");
    }
    if (!savedBankData) {
      toast.error("Please fill all the bank details");
    }

    const savedBanksNames = [
      "project_bank_details",
      "aurus_commission_bank_details",
      "development_bank_details",
      "registration_bank_details",
    ];

    if (!savedBanksNames.every((name) => savedBankData[name])) {
      toast.error("Please fill all the bank details");
      return;
    }

    const formData = {
      ...savedData,
      ...savedBankData,
    };
    const { success } = await createNewProject(formData);
    if (!success) {
      return;
    } else {
      localStorage.removeItem("new_project_data");
      localStorage.removeItem("currentFormStage");
      formStages.forEach((stage) => localStorage.removeItem(stage));
      toast.success("Project created successfully");
      localStorage.removeItem("modalStack");
      navigate(`/project-listing`);
    }
  };

  const breadcrumbs = [
    { name: "Project Listing", link: -1 },
    { name: "New Project", link: "/project-listing/add-new-project" },
  ];

  const handleClearForm = () => {
    localStorage.removeItem("new_project_data");
    localStorage.removeItem("currentFormStage");
    formStages.forEach((stage) => localStorage.removeItem(stage));
    setCurrentStep(0);
    window.location.reload();
  };

  return (
    <>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <ProjectForm id={formStages[0]} isCurrentStep={currentStep === 0} onNextStep={handleSetNextStep} />
      <ProjectAmenitiesForm id={formStages[1]} onNextStep={handleSetNextStep} isCurrentStep={currentStep === 1} />
      <ProjectNearbyForm id={formStages[2]} onNextStep={handleSetNextStep} isCurrentStep={currentStep === 2} />
      <ProjectPhasesForm id={formStages[3]} onNextStep={handleSetNextStep} isCurrentStep={currentStep === 3} />
      <BankDetailsForm id={formStages[4]} onNextStep={handleSetNextStep} isCurrentStep={currentStep === 4} />
      <div className="row end">
        <Button className="ghost_outline_round" onClick={handleClearForm}>
          Clear
        </Button>
        <Button className="submit" end onClick={handleSubmit} disabled={currentStep !== formStages.length - 1}>
          SUBMIT
        </Button>
      </div>
    </>
  );
};
export default NewProjectFormPage;
